import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { API_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllToolsData } from "./ToolsAction";

export const getAllToolsApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  const params = new URLSearchParams(ctx?.props?.location?.search);
  const searchValue = params.get("search") || "";  
  const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
  const pageSize = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const pageNumber = parseInt(params.get("page"), 10) || START_PAGE;
  return function (dispatch, getState) {

    return postLoginInstance.get(`tools?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${pageSize || API_LIMIT}&pageNumber=${pageNumber || START_PAGE}${searchValue && `&searchValue=${searchValue}`}`)
      .then((res) => {
        
        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllToolsData(res.data.data, pageNumber || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false})
      })
  }

};